document.addEventListener('DOMContentLoaded', function () {
  // Check URL hash
  if (!window.location.href.includes('#item-authenticity')) return;

  const target = document.querySelector('#faq-item-authenticity');
  if (!target) return;

  // Scroll to the FAQ item
  target.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });

  if (!target || !target.summaryElement) return;

  // Open accordion only if not already open
  if (!target.hasAttribute('open')) {
    target.summaryElement.click();
  }
});


const popup = document.getElementById("basketPopup");
const closeBtn = popup?.querySelector(".popup-close");

// Close popup
function closePopup() {
  popup.classList.remove("active");
  document.querySelector('body').classList.remove('overflow-hidden');
}

// Close on X button
closeBtn?.addEventListener("click", closePopup);

// Close on overlay click
popup?.addEventListener("click", (e) => {
  if (e.target === popup) {
      closePopup();
  }
});